<template>
  <login-form/>
</template>

<script>
import LoginForm from '../../components/forms/LoginForm'

export default {
  components: {
    LoginForm
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/SignIn.vue